/*
 * PIKA — „PŘIDEJ ZA X KČ A DOSTANEŠ MYSTERY GIFT" (3. 10. 2026, konverze).
 * Analýza: 19 % objednávek je v pásmu 2 500–2 999 Kč, tedy těsně pod prahem dárku (3 000 Kč).
 * V košíku (zásuvka i stránka /cart), když do dárku zbývá nejvýš 600 Kč, nabídne 2–4 kusy VLASTNÍHO zboží skladem,
 * jejichž cena práh dorovná. Nárok na dárek vzniká jen z vlastního zboží (ERP /api/v1/darek: narok, min_vlastni_czk),
 * proto se nabízí jen zboží z ERP `/api/v1/sety/vlastni` (celé `is_store_owned`).
 * Nic se nepřepisuje: skript se jen připojí na `window.__PIKA_DAREK.vykresli` (stav `posledni`: chybi, prah, narok, mena)
 * a použije `window.__PIKA_CART_UPSELL` (produkt, pridatDoplnek, stavKosiku). Čísla jsou skutečná: kus se nabídne,
 * jen když jeho nejnižší dostupná cena (v měně košíku) ≥ chybějící částka; žádné odpočty ani „zbývá N kusů".
 * Mount `[data-pika-dd]` je v `snippets/pika-kosik.liquid` pod seznamem položek (v posuvném těle, NE v patičce
 * s tlačítkem „Přejít k placení"). Načítá se odloženě (`defer`) ze `sections/cart-drawer.liquid`.
 */
(function () {
  'use strict';
  if (window.__PIKA_DD) return;
  window.__PIKA_DD = true;

  var EN = /^en/i.test(document.documentElement.getAttribute('lang') || '');
  var I18N = window.PIKA_I18N || {};
  function T(k) { return I18N['pikastore.w.darek_doplnek.' + k] || ''; }
  var LIMIT_CZK = 600;       // nabízí se jen když do dárku zbývá nejvýš tolik (v Kč, v eurech přepočteno kurzem)
  var POCET = 4;             // nejvýš kusů
  var PREKROCENI_CZK = 450;  // „blízko" = cena kusu nejvýš o tolik nad chybějící částkou
  var KLIC_NE = 'pikaDarekNe';

  var ERP = { p: null, t: 0 };
  var tokenBehu = 0;

  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function relace(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }

  function injectCss() {
    if (document.getElementById('pika-dd-css')) return;
    var s = document.createElement('style');
    s.id = 'pika-dd-css';
    s.textContent = [
      '.pika-dd{ margin:12px 0 4px; padding:12px 12px 10px; border:1px solid rgba(222,149,0,.45); border-radius:12px; background:rgba(222,149,0,.07); box-sizing:border-box; min-width:0; max-width:100%; }',
      '.pika-dd[hidden]{ display:none !important; }',
      '.pika-dd__nadpis{ margin:0 0 2px; font-size:14px; line-height:1.35; font-weight:600; }',
      '.pika-dd__nadpis b{ color:#a86f00; font-weight:700; }',
      '.pika-dd__pod{ margin:0 0 10px; font-size:12px; line-height:1.3; opacity:.65; }',
      /* rc3806 — řada se nescrolluje: karty se vejdou na šířku (4 na PC, 3 na telefonu), nic není useknuté. */
      '.pika-dd__rada{ display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:8px; overflow:hidden; }',
      '.pika-dd__rada::-webkit-scrollbar{ display:none; }',
      '.pika-dd__karta{ min-width:0; display:flex; flex-direction:column; gap:4px; padding:8px; border-radius:10px; background:#fff; border:1px solid rgba(0,0,0,.08); box-sizing:border-box; }',
      '.pika-dd__obr{ display:block; aspect-ratio:1/1; border-radius:8px; background:#f4f4f4; overflow:hidden; }',
      '.pika-dd__obr img{ width:100%; height:100%; object-fit:contain; mix-blend-mode:multiply; display:block; }',
      '.pika-dd__nazev{ font-size:12px; line-height:1.3; min-height:2.6em; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; color:inherit; text-decoration:none; }',
      '.pika-dd__cena{ font-size:13px; font-weight:700; }',
      '.pika-dd__pridat{ margin-top:2px; padding:7px 8px; min-height:34px; border-radius:8px; border:1px solid #DE9500; background:#DE9500; color:#fff; font:inherit; font-size:12.5px; font-weight:600; cursor:pointer; }',
      '.pika-dd__pridat:hover{ filter:brightness(.95); }',
      '.pika-dd__pridat[aria-busy="true"]{ opacity:.6; pointer-events:none; }',
      '.pika-dd__pridat:focus-visible{ outline:2px solid #DE9500; outline-offset:2px; }',
      '@media (max-width:740px){ .pika-dd{ margin:8px 0 2px; padding:10px 10px 8px; } .pika-dd__rada{ grid-template-columns:repeat(3,minmax(0,1fr)); gap:6px; } .pika-dd__karta{ padding:6px; } .pika-dd__karta:nth-child(n+4){ display:none; } .pika-dd__obr{ aspect-ratio:3/2; } }'
    ].join('\n');
    document.head.appendChild(s);
  }

  /* Kandidáti z ERP: vlastní zboží, nejprodávanější + nejlevnější (jedna dvojice dotazů, 10 min v paměti). */
  function kandidati(C) {
    if (ERP.p && Date.now() - ERP.t < 600000) return ERP.p;
    var zaklad = C.api + '/api/v1/sety/vlastni?store_slug=' + encodeURIComponent(C.slug) + '&pocet=24&razeni=';
    function nacti(r) {
      return fetch(zaklad + r, { headers: { accept: 'application/json' } })
        .then(function (x) { if (!x.ok) throw new Error('http ' + x.status); return x.json(); })
        .then(function (d) { return (d && Array.isArray(d.kusy)) ? d.kusy : []; })
        .catch(function () { return []; });
    }
    /* 25. 10. 2026 — šperky (kolekce chains: Chains 2026, vysoká marže) se přimíchají mezi doplňky (majitel: „přidat mezi už aktuální upselly“). */
    function nactiSperky() {
      return fetch('/collections/chains/products.json?limit=60', { headers: { accept: 'application/json' } })
        .then(function (x) { if (!x.ok) throw new Error('http ' + x.status); return x.json(); })
        .then(function (d) {
          return ((d && d.products) || []).filter(function (pr) {
            return (pr.variants || []).length === 1 && (pr.variants || []).some(function (vv) { return vv.available; });
          }).map(function (pr) { return { handle: pr.handle, cena: Number(pr.variants[0].price), sperk: true }; });
        })
        .catch(function () { return []; });
    }
    var p = Promise.all([nacti('oblibene'), nacti('nejlevnejsi'), nactiSperky()]).then(function (v) {
      var out = [], videno = {};
      v[0].concat(v[1]).forEach(function (k, i) {
        if (!k || !k.handle || videno[k.handle]) return;
        var cena = Number(k.cena);
        if (!(cena > 0)) return;
        videno[k.handle] = 1;
        out.push({ handle: k.handle, cena: cena, barvy: Array.isArray(k.barvy) ? k.barvy : [], poradi: i });
      });
      /* Šperky v náhodném pořadí (střídají se), označené `sperk`; výběr je pak proloží s ostatními. */
      var sp = v[2].slice().sort(function () { return Math.random() - 0.5; });
      sp.forEach(function (k, i) {
        if (!k.handle || videno[k.handle] || !(k.cena > 0)) return;
        videno[k.handle] = 1;
        out.push({ handle: k.handle, cena: k.cena, barvy: [], poradi: 1000 + i, sperk: true });
      });
      if (!out.length) { ERP.p = null; }
      return out;
    });
    ERP.p = p; ERP.t = Date.now();
    return p;
  }

  function mounty() {
    return document.querySelectorAll('cart-drawer [data-pika-dd], #pika-kosik-stranka [data-pika-dd]');
  }
  function skryj() {
    var m = mounty();
    for (var i = 0; i < m.length; i++) { if (!m[i].hidden || m[i].firstChild) { m[i].hidden = true; m[i].innerHTML = ''; m[i].removeAttribute('data-podpis'); } }
  }

  function vykresli(st) {
    var C = window.__PIKA_CART_UPSELL;
    if (!C || !mounty().length) return;
    if (!st || !st.d || relace(KLIC_NE) === '1' || !(st.prah > 0)) { tokenBehu++; skryj(); return; }
    var d = st.d;
    var kurz = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var mena = st.mena || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CZK';
    var minVlastniC = Math.ceil(Number(d.min_vlastni_czk || 250) * kurz * 100);
    var potreba = Math.max(0, Number(st.chybi) || 0);
    if (!d.narok) {
      /* Bez nároku (jen komise / vlastní zboží pod minimem): kus musí splnit i minimum vlastního zboží. */
      if (d.duvod !== 'jen_komise' && d.duvod !== 'vlastni_pod_minimem') { tokenBehu++; skryj(); return; }
      var vlC = Math.max(0, Math.round(Number(d.vlastni_czk || 0) * kurz * 100));
      potreba = Math.max(potreba, minVlastniC - vlC);
    }
    if (!(potreba > 0) || potreba > LIMIT_CZK * kurz * 100) { tokenBehu++; skryj(); return; }

    var potrebaCelk = Math.ceil(potreba / 100) * 100;      // v hlavičce zaokrouhleno nahoru na celé Kč / €
    var sig = [potrebaCelk, mena].join('|');
    var token = ++tokenBehu;
    Promise.all([kandidati(C), C.stavKosiku()]).then(function (v) {
      if (token !== tokenBehu) return;
      var kand = v[0], cart = v[1];
      var vKosiku = {};
      ((cart && cart.items) || []).forEach(function (it) { if (it.handle) vKosiku[it.handle] = 1; });
      var hranice = potreba * 0.9;
      var pool = kand.filter(function (k) {
        return !vKosiku[k.handle] && k.cena * kurz * 100 >= hranice && (k.cena - potreba / kurz / 100) <= 1000;
      }).sort(function (a, b) { return a.poradi - b.poradi; });
      /* Do kola ověření jdou nejvýš 4 šperky + 10 ostatních, ať šperky nevytlačí trenky a ponožky. */
      var poolSp = pool.filter(function (k) { return k.sperk; }).slice(0, 4);
      pool = pool.filter(function (k) { return !k.sperk; }).slice(0, 10).concat(poolSp);
      if (!pool.length) { skryj(); return; }
      return Promise.all(pool.map(function (k) {
        return C.produkt(k.handle).then(function (pd) {
          if (!pd) return null;
          var dost = (pd.variants || []).filter(function (x) { return x.available; });
          if (!dost.length) return null;
          var od = Math.min.apply(null, dost.map(function (x) { return x.price; }));
          /* Garance: i nejlevnější dostupná varianta práh dorovná. */
          if (!(od >= potreba)) return null;
          return { k: k, pd: pd, od: od, ruzne: od !== Math.max.apply(null, dost.map(function (x) { return x.price; })) };
        }).catch(function () { return null; });
      })).then(function (r) {
        if (token !== tokenBehu) return;
        r = r.filter(Boolean);
        var limBlizko = potreba + PREKROCENI_CZK * kurz * 100;
        var blizko = r.filter(function (x) { return x.od <= limBlizko; });
        var dalsi = r.filter(function (x) { return x.od > limBlizko; });
        var serazene = blizko.concat(dalsi);
        /* rc3806 — šperk nikdy první: nejdřív ostatní kusy, šperky (nejvýš 2) až na konci řady. */
        var ost = serazene.filter(function (x) { return !x.k.sperk; });
        var spe = serazene.filter(function (x) { return x.k.sperk; }).slice(0, 2);
        var vyber = ost.slice(0, POCET - spe.length);
        while (vyber.length < POCET && spe.length) vyber.push(spe.shift());
        if (!vyber.length) { skryj(); return; }
        kresli(C, vyber, potrebaCelk, mena, sig + '|' + vyber.map(function (x) { return x.k.handle + ':' + x.od; }).join(','));
      });
    }).catch(function () {});
  }

  function penize(c, mena) {
    var v = c / 100;
    try {
      return new Intl.NumberFormat(EN ? 'en-IE' : 'cs-CZ', { style: 'currency', currency: mena, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v);
    } catch (e) { return Math.round(v) + ' ' + mena; }
  }
  function kratce(t) { return String(t || '').replace(/\s*-\s*PIKASTORE\s*$/i, ''); }

  function kresli(C, vyber, potrebaCelk, mena, podpis) {
    var m = mounty();
    for (var i = 0; i < m.length; i++) {
      var mount = m[i];
      if (mount.getAttribute('data-podpis') === podpis && mount.firstChild) { mount.hidden = false; continue; }
      mount.setAttribute('data-podpis', podpis);
      mount.innerHTML = '';
      mount.setAttribute('role', 'group');
      mount.setAttribute('aria-label', T('add_ons'));
      var castka = penize(potrebaCelk, mena);
      var h = el('p', 'pika-dd__nadpis');
      h.appendChild(document.createTextNode(T('add_prefix')));
      h.appendChild(el('b', null, castka));
      h.appendChild(document.createTextNode(T('add_suffix')));
      mount.appendChild(h);
      mount.appendChild(el('p', 'pika-dd__pod', T('any_one')));
      var rada = el('div', 'pika-dd__rada');
      vyber.forEach(function (x) {
        var k = el('div', 'pika-dd__karta');
        var a = el('a', 'pika-dd__obr');
        a.href = '/products/' + x.k.handle;
        a.setAttribute('tabindex', '-1');
        a.setAttribute('aria-hidden', 'true');
        if (x.pd.image) {
          var im = el('img');
          im.alt = '';
          im.loading = 'lazy';
          im.width = 160; im.height = 160;
          im.src = x.pd.image + (x.pd.image.indexOf('?') >= 0 ? '&' : '?') + 'width=160';
          a.appendChild(im);
        }
        k.appendChild(a);
        var n = el('a', 'pika-dd__nazev', kratce(x.pd.title));
        n.href = '/products/' + x.k.handle;
        k.appendChild(n);
        k.appendChild(el('span', 'pika-dd__cena', (x.ruzne ? T('from_prefix') : '') + penize(x.od, mena)));
        var b = el('button', 'pika-dd__pridat', T('add'));
        b.type = 'button';
        b.setAttribute('aria-label', T('add_aria_prefix') + kratce(x.pd.title) + ' – ' + penize(x.od, mena));
        b.addEventListener('click', function () {
          /* kdo přidává kvůli dárku, přišel pro dárek: dřívější vypnutí se ruší (jako v nabídce dárku) */
          try { sessionStorage.removeItem(KLIC_NE); } catch (e) {}
          if (window.__PIKA_DAREK && window.__PIKA_DAREK.posledni) window.__PIKA_DAREK.posledni.chce = true;
          C.pridatDoplnek(x.k.handle, b, { barvy: x.k.barvy, minHodnota: 0 });
        });
        k.appendChild(b);
        rada.appendChild(k);
      });
      mount.appendChild(rada);
      mount.hidden = false;
    }
  }

  injectCss();
  var pokusy = 0;
  function pripoj() {
    var D = window.__PIKA_DAREK;
    if (!D || !window.__PIKA_CART_UPSELL) return false;
    if (!D.__ddObalen) {
      D.__ddObalen = true;
      var puvodni = D.vykresli;
      D.vykresli = function () {
        var r = puvodni.apply(this, arguments);
        try { vykresli(this.posledni); } catch (e) {}
        return r;
      };
    }
    try { if (D.posledni) vykresli(D.posledni); } catch (e) {}
    return true;
  }
  /* Košíkové skripty se načítají odloženě (ikona košíku / přidání / idle) — počkat, až budou. */
  var t = setInterval(function () { if (pripoj() || ++pokusy > 240) clearInterval(t); }, 500);
  document.addEventListener('pika:darek-cil', function () { pripoj(); });
})();
